import React, {useCallback, useState} from "react";
import clsx from "clsx";
import {Input, Typography} from "antd";
import {CustomButton} from "../../Button";
import {useHistory} from "react-router-dom";
import classes from "../EmailNotifications.module.scss";

const {Title} = Typography;
const {Search} = Input;

interface EmailHeader {
    onSearch: (value: string) => void;
    value: string;
}

const EmailHeader: React.FC<EmailHeader>  = ({onSearch, value}) => {
    const history = useHistory();
    const [inputValue, setValue] = useState(value);
    const onAddEmailNotification = () => {
        history.push("/user/setting/add/notification");
    };

    const onChange = useCallback(({target: {value}}) => {
        setValue(value);
    }, [setValue]);

     const onReset = useCallback(() => {
            setValue(''); // Clear the local input state
            onSearch(''); // Trigger a search with an empty string
        }, [onSearch]);

    return (
        <div>
            <div className={clsx("d-flex", "d-flex-w")}>
                <div>
                    <Title level={2}>Settings - E-mail Notifications</Title>
                </div>

                <div className="d-flex">
                    <CustomButton width="94px"
                                  height="40px"
                                  padding="2px 2px"
                                  fontSize="13px"
                                  className="mar-right-10"
                                  htmlType="button"
                                  onClick={onAddEmailNotification}
                    >
                        <span>+ ADD</span>
                    </CustomButton>
                </div>

            </div>
            <div className={classes.searchEmailWrap}>
                <div className={classes.searchEmail}>
                    <Search
                        placeholder="Filter by email or device"
                        onChange={onChange}
                        onSearch={onSearch}
                        value={inputValue}
                        loading={false}
                        enterButton
                        size="large"
                    />
                    <CustomButton onClick={onReset} color="gray" height="40px" width="100px">
                        Reset
                    </CustomButton>
                </div>

            </div>
        </div>
    );
};

export default EmailHeader;